// extracted by mini-css-extract-plugin
export default {"redAsterisk":"style_redAsterisk__qSSRN"};